// Utils / Constants
import { getLabelKebabCase } from './metric-selector-modal-pipes-utils';
import * as i0 from "@angular/core";
/**
 * Create a unique string to identify the first element in a category's metric.
 * This is used to scroll to the top of each category's metrics.
 *
 * Value:
 *   metricByCategoryListId: The string identifying which component extending MetricByCategoryListDirective includes
 *     the item to scroll to. This is necessary because more than one of those components can exist on the same page.
 *
 * Params:
 *   categoryLabel: The label of the category this is the broadest way metrics are grouped.
 *
 */
export class GetCategoryScrollIdPipe {
    transform(metricByCategoryListId, categoryLabel) {
        return getLabelKebabCase([categoryLabel, metricByCategoryListId]);
    }
}
GetCategoryScrollIdPipe.ɵfac = function GetCategoryScrollIdPipe_Factory(t) { return new (t || GetCategoryScrollIdPipe)(); };
GetCategoryScrollIdPipe.ɵpipe = /*@__PURE__*/ i0.ɵɵdefinePipe({ name: "getCategoryScrollId", type: GetCategoryScrollIdPipe, pure: true });
